"use client"

import { Dialog, DialogBackdrop, DialogPanel } from "@headlessui/react"
import InputQuantity from "../commons/InputQuantity"
import { useEffect, useState } from "react"
import DialogConfirmation from "./DialogConfirmation"
import { createOffer } from "../../firebase/offers"
import { useAtom } from "jotai"
import { userAtom } from "../../store"
import { loadStripe } from '@stripe/stripe-js';
import { Elements } from '@stripe/react-stripe-js';
import PaymentForm from "../PaymentForm"
import CheckoutForm from "../forms/CheckoutForm"


export default function DialogPaymentForm({
    open,
    onClose,
}) {
    const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLIC_KEY)

    const [clientSecret, setClientSecret] = useState("");

    // useEffect(() => {
    //     // Create PaymentIntent as soon as the page loads
    //     fetch("http://localhost:4000/create-payment-intent", {
    //         method: "POST",
    //         headers: { "Content-Type": "application/json" },
    //         body: JSON.stringify({ items: [{ id: "xl-tshirt", amount: 1000 }] }),
    //     })
    //         .then((res) => res.json())
    //         .then((data) => setClientSecret(data.clientSecret));

    //     createPaymentMethod()
    // }, []);

    const createPaymentMethod = async () => {
    }

    const appearance = {
        theme: 'stripe',
        variables: {
            colorPrimary: '#292929',
        },
    };
    // Enable the skeleton loader UI for optimal loading.
    const loader = 'auto';

    return (
        <>
            <Dialog open={open} onClose={onClose} className="relative z-[10000]">
                <DialogBackdrop
                    transition
                    className="fixed inset-0 bg-[#000] backdrop-blur-sm bg-opacity-75 transition-opacity"
                />

                <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
                    <div className="flex min-h-full items-center justify-center p-4 sm:p-0">
                        <DialogPanel
                            transition
                            className="relative transform overflow-hidden bg-[#141414] backdrop-blur-sm shadow-xl transition-all data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in w-full max-w-[604px]"
                        >
                            {/* {clientSecret &&
                                <Elements options={{ clientSecret, appearance, loader }} stripe={stripePromise}>
                                    <CheckoutForm />
                                </Elements>
                            } */}
                            <Elements stripe={stripePromise}>
                                <PaymentForm />
                            </Elements>

                        </DialogPanel>
                    </div>
                </div>
            </Dialog>
        </>
    )
}
